import React from 'react';
import { Route, Switch } from 'react-router';

import { LeaseAgreementTable } from '@klp/leaseagreements';
import { LevendeKontrakter } from '@klp/levendekontrakter';

import { ContractManagementTabs } from '../classes';
import { ContractManagementRoutes } from '../config';

export const ContractManagementContent: React.FC = () => {
    return (
        <Switch>
            <Route
                path={ContractManagementRoutes.tab(
                    ContractManagementTabs.levendekontrakter,
                )}
            >
                <LevendeKontrakter />
            </Route>
            <Route
                path={ContractManagementRoutes.tab(
                    ContractManagementTabs.avtaler,
                )}
            >
                <LeaseAgreementTable />
            </Route>
        </Switch>
    );
};

ContractManagementContent.displayName = 'Contracts';
